import type { UriType } from '~/model/GlobalTypes';

export function getErrorCodeFromUri(uri: UriType) {
  const match = uri?.match(/\d+/); // Regular expression to match one or more digits
  return match ? Number.parseInt(match[0], 10) : null; // Return the number or null if no match
}
